import { render } from "./splashvideomodal.vue?vue&type=template&id=4c2b1738"
import script from "./splashvideomodal.vue?vue&type=script&lang=js"
export * from "./splashvideomodal.vue?vue&type=script&lang=js"

import "./splashvideomodal.vue?vue&type=style&index=0&id=4c2b1738&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__